import { SecretsService } from '../services/SecretsService'
import { AppConfigKey } from '../constants/AppConfigKey'
import { LOCAL_STORAGE } from '../services/LocalStorage'
import { SessionKey } from '../constants/SessionKey'

// The Azure search service requires an API key that is not empty as a base requirement.
// The secrets cannot be read when a user is logged out because the unauthenticated role
// has denied permissions on the AWS Secrets Manager service. When the user is logged out
// the value of the various secrets will be set to the value below.
const NON_EMPTY_STRING = 'NON_EMPTY_STRING'

// The list of secrets to retrieve and their associated sessions keys
const SECRET_NAMES = [
  {
    name: AppConfigKey.GCL_PRIVATE_ROUTE_AUTH_CODE,
    key: SessionKey.PRIVATE_ROUTE_AUTH_CODE
  },
  {
    name: AppConfigKey.GCL_AZURE_SEARCH_ADMIN_KEY,
    key: SessionKey.AZURE_SEARCH_ADMIN_KEY
  },
  {
    name: AppConfigKey.GCL_AZURE_SEARCH_API_KEY,
    key: SessionKey.AZURE_SEARCH_API_KEY
  },
  {
    name: AppConfigKey.GCL_GOOGLE_MAPS_API_KEY,
    key: SessionKey.GOOGLE_MAPS_API_KEY
  },
  {
    name: AppConfigKey.GCL_SES_ROLE_EXT_ID,
    key: SessionKey.SES_ROLE_EXT_ID
  },
  {
    name: AppConfigKey.GCL_B4A_API_KEY,
    key: SessionKey.PARSE_API_KEY
  },
  {
    name: AppConfigKey.GCL_B4A_JS_KEY,
    key: SessionKey.PARSE_JS_KEY
  }
]

export class SecretsConfig {
  private static _instance: SecretsConfig

  async initialize() {
    const service = new SecretsService()
  
    // Create an array of promises for all get secret operations
    const secretPromises = SECRET_NAMES.map(async (curSecret) => {
      const value = await service.getSecretValue(curSecret.name)
      LOCAL_STORAGE.set(curSecret.key, value)
    })
  
    // Wait for all promises to resolve concurrently
    await Promise.all(secretPromises)
  }

  static getInstance() {
    return this._instance || (this._instance = new this())
  }

  getPrivateAuthCode(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.PRIVATE_ROUTE_AUTH_CODE, NON_EMPTY_STRING)!
  }

  getBack4AppApiKey(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.PARSE_API_KEY, NON_EMPTY_STRING)!
  }

  getBack4AppJSKey(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.PARSE_JS_KEY, NON_EMPTY_STRING)!
  }

  getAzureSearchAdminKey(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.AZURE_SEARCH_ADMIN_KEY, NON_EMPTY_STRING)!
  }

  getAzureSearchApiKey(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.AZURE_SEARCH_API_KEY, NON_EMPTY_STRING)!
  }

  getGoogleMapsApiKey(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.GOOGLE_MAPS_API_KEY, NON_EMPTY_STRING)!
  }

  getSesRoleExternalId(): string {
    return LOCAL_STORAGE.getOrDefault(SessionKey.SES_ROLE_EXT_ID, NON_EMPTY_STRING)!
  }
}

export default SecretsConfig

export const SECRETS_CONFIG = SecretsConfig.getInstance()
